import React from "react";

/**
 * A handled finding collapses to a receipt (§B3 law 3 / §B4) — reversible where
 * the data change is (a policy inactivate can be reactivated), and it says so.
 * `dismissed` renders the muted variant. onUndo is optional: the pinned queue
 * has no un-resolve, so v1 only offers Undo where a real reversal exists (the
 * reactivate path); a receipt with no reversal simply states the outcome.
 */
function ReceiptRow({ label, dismissed = false, onUndo, undoLabel = "Undo" }) {
  return (
    <div className={`feat-receipt${dismissed ? " feat-receipt--dismissed" : ""}`}>
      <span className="feat-receipt__mark" aria-hidden="true">
        {dismissed ? "–" : "✓"}
      </span>
      <span className="feat-receipt__label">{label}</span>
      {onUndo ? (
        <button type="button" className="feat-receipt__undo" onClick={onUndo}>
          {undoLabel}
        </button>
      ) : null}
    </div>
  );
}

export default ReceiptRow;
